import IComponent from "components/commons/IComponent";
import "./LayerSetting.scoped.css";
import SwitchButton from "components/commons/SwitchButton";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import OpacitySlider from "./OpacitySlider";
import GetArcGISToken from "utils/GetArcGISToken";
let cachedMultiLevelDef = {};
class Layer2DList extends IComponent {
  constructor(props) {
    super(props);
  }
  makeMultiLevelLut(layer) {
    if (cachedMultiLevelDef[layer.id]) return cachedMultiLevelDef[layer.id];
    var output = layer.allSublayers
      .map((i) => [i, i.title, i.parent.title])
      .sort((a, b) => a[0].id - b[0].id)
      .reduce((p, c, i) => {
        if (!(c[2] in p)) p[c[2]] = [];
        p[c[2]].push({
          layer: c[0],
          title: c[1],
          parent: c[2],
        });
        return p;
      }, {});
    console.debug(output);
    if (Object.keys(output).lenght > 0) cachedMultiLevelDef[layer.id] = output;
    return output;
  }
  makeMultiLevelLayer(layerList, level) {
    var vm = this;
    if (!(level in layerList))
      return (
        <div className="SubPanelContent" style={{ color: "var(--error)" }}>
          Error loading the layer
        </div>
      );
    return (
      <div>
        {layerList[level].map((item, i) => (
          <div
            key={`C${item.title + "-" + i}`}
            className="ListItemBottomLine SubPanelContent"
            style={{
              display:
                this.props.showActiveItem && !item.layer.visible ? "none" : "",
            }}
          >
            <SwitchButton
              label={item.title in layerList ? <b>{item.title}</b> : item.title}
              placeAtRight={true}
              checked={item.layer.visible}
              onClick={() => {
                this.layersHandle(item);
              }}
            />
            {item.title in layerList &&
              item.layer.visible &&
              item.parent != item.title &&
              vm.makeMultiLevelLayer(layerList, item.title)}
          </div>
        ))}
      </div>
    );
  }
  async layersHandle(item) {
    let userGroup = GetArcGISToken.user.userGroup;
    let showMsg = !item.layer.visible;
    if (showMsg) {
      switch (item.title) {
        case "Unauthorized Slope Works":
          if (userGroup === 4 || userGroup === 5 || userGroup === 6) {
            this.props.showDialog({
              isOpen: true,
              type: "error",
              title: "Access Denied",
              content: "You don't have permission to access this layer.",
              onDialogOk: () => {},
            });
          } else {
            this.props.showDialog({
              isOpen: true,
              title: "Reminder",
              content:
                "The USW polygon as shown is the approximate extent observed at the time of inspection and this USW layer is only used for internal file search reference. Update of the digitised approximate extent of USW is generally not required.",
              onDialogOk: () => {
                item.layer.visible = !item.layer.visible;
                this.setState({});
              },
            });
          }
          return;
        case "MTR Protection Zone":
        case "Protection Area":
          this.props.showDialog({
            isOpen: true,
            title: "Reminder",
            content: (
              <span>
                The MTR protection zone is converted from spatial layer given in
                the LIC Base Map. The MTR maintains the most up-to-date railway
                protection zone and can be accessed in their{" "}
                <a
                  href="http://www.mtr.com.hk/en/corporate/operations/protection_boundary_map.html"
                  target="_blank"
                >
                  <u>website</u>
                </a>
                .
              </span>
            ),
            onDialogOk: () => {
              item.layer.visible = !item.layer.visible;
              this.setState({});
            },
          });
          return;
      }
    }
    item.layer.visible = !item.layer.visible;
    this.setState({});
  }
  render() {
    let vm = this;
    let layerList = this.$config[`mapList${this.props.isSecondMap ? "2" : ""}`];
    if (!layerList) return <div />;
    let all2DLayers = layerList.layer2D;
    let layer2DIdx = all2DLayers.findIndex((i) => i.layer.visible);
    layer2DIdx = layer2DIdx == -1 ? undefined : layer2DIdx;
    let mapState = { layer2DIdx };
    let layer = all2DLayers?.[layer2DIdx]?.layer;
    let lyrList = layerList["overlays"].filter(
      (lyr) => lyr.title == "Man Made Slope"
    );
    console.debug("Layer2DList updated");
    return (
      <div>
        <div
          className="SubPanelContent ListItemBottomLine"
          style={{ padding: "15px 20px 15px 10px" }}
        >
          <EditableDatagridCell
            cellInfo={{
              row: mapState,
              colDef: {
                naText: "- None -",
                field: "layer2DIdx",
                dataType: "dropdown",
                values: all2DLayers.map((i, j) =>
                  i.layer?.title ? `${i.layer.title}` : ""
                ),
              },
            }}
            onChange={(field, value, values) => {
              console.debug(value);
              all2DLayers.forEach((i, j) => {
                i.layer.visible = j == value;
                i.layer.opacity = 1;
              });

              // link to state of overlay of man-made feature
              if (all2DLayers.some((i) => i.layer.visible) == true) {
                let Vlayer2DIdx = all2DLayers.findIndex((i) => i.layer.visible);
                Vlayer2DIdx = Vlayer2DIdx == -1 ? undefined : Vlayer2DIdx;
                let Vlayer = all2DLayers?.[Vlayer2DIdx]?.layer;
                if (lyrList[0].layer.visible == false) {
                  let MMS = this.makeMultiLevelLut(Vlayer)[
                    "Slope and Catchment"
                  ]?.filter((l) => l.title === "Man-made Features");
                  if (MMS) {
                    MMS[0].layer.visible = false;
                  }

                  let MMS_2 = this.makeMultiLevelLut(Vlayer)["Slope"]?.filter(
                    (l) => l.title === "Man-made Features"
                  );
                  if (MMS_2) {
                    MMS_2[0].layer.visible = false;
                  }

                  let SI = this.makeMultiLevelLut(Vlayer)["Annotation"]?.filter(
                    (l) => l.title === "Slope Features"
                  );

                  if (SI) {
                    SI[0].layer.visible = false;
                  }
                } else {
                  let MMS = this.makeMultiLevelLut(Vlayer)[
                    "Slope and Catchment"
                  ]?.filter((l) => l.title === "Man-made Features");

                  if (MMS) {
                    MMS[0].layer.visible = true;
                  }

                  let MMS_2 = this.makeMultiLevelLut(Vlayer)["Slope"]?.filter(
                    (l) => l.title === "Man-made Features"
                  );
                  if (MMS_2) {
                    MMS_2[0].layer.visible = true;
                  }

                  let SI = this.makeMultiLevelLut(Vlayer)["Annotation"]?.filter(
                    (l) => l.title === "Slope Features"
                  );

                  if (SI) {
                    SI[0].layer.visible = true;
                  }
                }
              }

              vm.setState({});
            }}
          />
          {!!layer && <OpacitySlider layer={layer} />}
        </div>
        {!!layer &&
          this.makeMultiLevelLayer(this.makeMultiLevelLut(layer), layer.title)}
      </div>
    );
  }
}

export default Layer2DList;
